import React from "react";
import hero1 from "../../images/hero/image-7.jpg";
import shape1 from "../../images/hero/text-shape.svg";
import shape2 from "../../images/hero/text-img-1.jpg";

const Hero5: React.FC = () => {
  return (
    <section className="wpo-hero-slider-s5">
      <div className="container-fluid">
        <div className="hero-wrapper">
          <div className="row">
            <div className="col-lg-12">
              <div className="hero-content">
                <div className="slide-title">
                  <h2 className="splittext-line">
                    Turning Your Love{" "}
                    <span>
                      <img
                        className="image-1"
                        src={shape1}
                        alt="Decorative shape"
                      />
                    </span>
                    Story Into a Perfect{" "}
                    <span>
                      <img src={shape2} alt="Decorative text" />
                    </span>
                    Celebration.
                  </h2>
                </div>
                <div className="hero-image">
                  <img src={hero1} alt="Wedding celebration" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero5;
